import LazyLoad from "react-lazyload";

import dynamic from "next/dynamic";

import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import FormCountries from "components/molecules/FormCountries";
import Banner from "components/organisms/Banner/index.js";
import RequiredDocument from "components/organisms/RequiredDocument";
const NewsSlider = dynamic(() => import("components/organisms/NewsSlider"), {
  ssr: false,
});

/** ========== */

const Component = ({ dataJson, data }) => {
  return (
    <>
      <Banner
        minHeightBanner="banner-min-h-635"
        breadcrumbs={dataJson?.breadcrumbs}
        title="Vietnam Immigration<br/>Service"
        titleProps={{
          className:
            " xl:text-5xl mb-6 text-bbc-30px font-semibold  xl:leading-[50px] text-center lg:text-left ",
          textColor: "banner-title-default-color",
        }}
        leftContent={
          <div className="mb-14 text-center lg:col-11 lg:text-left">
            Make Vietnam the next place for your business venture. Get your Visa
            now and start making moves.
          </div>
        }
        leftClassName="lg:col-6"
        rightClassName="lg:col-5"
        rightContent={
          <Img
            src="/assets/images/vn/immigration-service/banner-vn-immigration.png"
            wrapper={{
              className: "bbc-banner-image-bottom-0",
            }}
            className="w-full"
            width={629}
            height={500}
            alt="Vietnam visa and immigration services"
          />
        }
        bgColor="bg-bbc-country"
      ></Banner>
      <section className="mt-10 lg:mt-20">
        <div className="container">
          <Title className="title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10">
            Vietnam business/work visa & permit requirements
          </Title>
          <p className="mb-6">
            Pursuant to Law, 51/2019/QH14 on entry, exit, transit, and residence
            of foreigners in Vietnam effective from July 1st, 2020, Vietnam
            visas can be categorized into 21 types.
          </p>
          <p className="mb-10">
            Most common ones include: business visa, investor visa, work visa,
            etc.
          </p>
          <Title
            as="h3"
            className="mb-6 text-2xl font-semibold text-bbc-brand-700"
          >
            Business visa
          </Title>
          <p className="mb-6">
            Business visas (Vietnam DN visas) are short-term visas that allow
            foreigners visiting Vietnam for business purposes to enter and stay
            in the country for up to 12 months.
          </p>
          <p className="mb-10">
            DN1 visas are granted to foreigners working for legally operating
            enterprises and organizations in Vietnam, meanwhile DN2 visas are
            issued to foreigners who travel to Vietnam to promote services, or
            conduct other business activities under international conventions.
          </p>
          <Title
            as="h3"
            className="mb-6 text-2xl font-semibold text-bbc-brand-700"
          >
            Work permit
          </Title>
          <p className="mb-6">
            Vietnam work permits are official certificates approved by the
            Department of Labor, Invalid and Social Affairs that allow their
            holders to legally work in Vietnam. This visa is valid for a maximum
            of 2 years.
          </p>
          <p>
            The employer is responsible for submitting an application for
            approval of the use of foreign workers at least 30 days before the
            foreign worker&lsquo;s employment at the company.
          </p>
        </div>
      </section>
      <section>
        <RequiredDocument
          title="Required Documents"
          data={dataJson.dataRequiredDocument}
          backgroundImage="/assets/images/common/required-documents.png"
          sectionClassName="py-10 lg:py-20 "
        />
      </section>
      <section>
        <div className="container">
          <Title className="title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10">
            Our pricing
          </Title>
          <div className="row justify-center">
            <div className="mb-6 lg:col-4 lg:mb-0">
              <div className="flex h-full flex-col justify-between rounded-3xl border-0  border-transparent  bg-white lg:border-4 ">
                <div className="border-b border-b-bbc-neutral-500 px-3 pt-10 pb-[76px] text-center ">
                  <p className="mb-10  text-2xl font-semibold capitalize tracking-[0.25px] text-bbc-brand-700">
                    Work permit
                  </p>
                  <p className="text-[50px] font-bold leading-[70px] tracking-[0.25px] text-bbc-yellow-500">
                    US$550
                  </p>
                </div>
                <p className="px-7 pt-10 pb-[50px]">
                  Work permit is issued to foreign skilled workers to be
                  employed in Vietnam, typically for 1 or 2 years at its max
                  length.
                </p>
              </div>
            </div>
            <div className="lg:col-4 ">
              <div className="flex h-full flex-col justify-between rounded-3xl border-0  border-transparent  bg-white lg:border-4 ">
                <div className="border-b border-b-bbc-neutral-500 px-3 pt-10 pb-[76px] text-center ">
                  <p className="mb-10  text-2xl font-semibold capitalize tracking-[0.25px] text-bbc-brand-700">
                    Vietnam business visa
                  </p>
                  <p className="text-[50px] font-bold leading-[70px] tracking-[0.25px] text-bbc-yellow-500">
                    US$650
                  </p>
                </div>
                <p className="px-7 pt-10 pb-[50px]">
                  Business visa allows you to work in Vietnam with an invitation
                  letter from a local business partner. It has a maximum
                  validity of 12 months.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="m-auto lg:col-10">
            <FormCountries
              title="Wish to get a fuss-free visa application in Vietnam"
              description="Just get in touch with us. We typically response within 2 hrs."
              country_id={244}
            />
          </div>
        </div>
      </section>
      <section className="mb-0">
        <div className="container">
          <Title className="title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800">
            Industry News & Insights
          </Title>
          <LazyLoad>
            <NewsSlider data={data} />
          </LazyLoad>
        </div>
      </section>
    </>
  );
};

export default Component;
